import {
  Button,
  Container,
  MtBookingCard,
  MtLayoutTitleWrapper,
  Section,
  SectionTitle,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { PageSkeleton } from './components/PageSkeleton';
import * as Styled from './styled';
import type { MtBookingsPageProps } from './types';

export * from './types';

export const MtBookingsPage: FC<MtBookingsPageProps> = (props) => {
  const {
    items = [],
    upcomingItems = [],
    onProListClick,
    onDeleteBookingClick,
    onUpdateBookingClick,
    loading = false,
  } = props;
  const { translate } = useTranslation();

  return (
    <Container>
      <Section>
        <MtLayoutTitleWrapper>
          <SectionTitle>{translate('mt.buyer.booking.titleFuture')}</SectionTitle>
        </MtLayoutTitleWrapper>
        {loading && <PageSkeleton />}
        {!loading && !upcomingItems.length && (
          <Styled.EmptyWrapper>
            <div>{translate('mt.buyer.booking.noFuture')}</div>
            <Button onClick={onProListClick} color="blue" shrink>
              {translate('common.buttons.seePros')}
            </Button>
          </Styled.EmptyWrapper>
        )}
        {!loading && !!upcomingItems?.length && (
          <Styled.CardContainer>
            {upcomingItems.map((booking, index) => (
              <Styled.CardWrapper key={index}>
                <MtBookingCard
                  upcoming
                  booking={booking}
                  onDeleteClick={() => onDeleteBookingClick?.(booking.id)}
                  onUpdateClick={() => onUpdateBookingClick?.(booking.id)}
                />
              </Styled.CardWrapper>
            ))}
          </Styled.CardContainer>
        )}
      </Section>
      <Section>
        <MtLayoutTitleWrapper>
          <SectionTitle>{translate('mt.buyer.booking.titlePast')}</SectionTitle>
        </MtLayoutTitleWrapper>
        {loading && <PageSkeleton />}
        {!loading && !items.length && (
          <Styled.EmptyWrapper>
            <div>{translate('mt.buyer.booking.noPast')}</div>
          </Styled.EmptyWrapper>
        )}
        {!loading && !!items?.length && (
          <Styled.CardContainer>
            {items.map((booking, index) => (
              <Styled.CardWrapper key={index}>
                <MtBookingCard
                  booking={booking}
                  onDeleteClick={() => onDeleteBookingClick?.(booking.id)}
                  onUpdateClick={() => onUpdateBookingClick?.(booking.id)}
                />
              </Styled.CardWrapper>
            ))}
          </Styled.CardContainer>
        )}
      </Section>
    </Container>
  );
};
